import logUtil from 'utils/log'

/**
 * @param props
 * @param props.hasFullSizeItems
 * @param props.hasGiftCard
 * @param props.hasReachedCheckoutMinimum
 * @param props.isMixedCollectionUrl
 */
const hasExpressCheckoutCartSelectUtil = (props) => {
  const {
    hasFullSizeItems,
    hasGiftCard,
    hasReachedCheckoutMinimum,
    isMixedCollectionUrl
  } = props

  logUtil('hasExpressCheckoutCartSelectUtil').debug('props=', props)
  if (!hasReachedCheckoutMinimum) {
    return false
  }

  if (isMixedCollectionUrl) {
    return true
  }

  return hasFullSizeItems || hasGiftCard
}

export default hasExpressCheckoutCartSelectUtil
